<template>
  <a-modal
      title="积分记录"
      :visible="visible"
      width="90%"
      style="top: 20px"
      :footer="null"
      @cancel="handleCancel"
  >
    <div class="points-detail">
      <!-- 搜索区域 -->
      <a-form layout="inline" :form="searchForm" class="custom-search-form">
        <a-row :gutter="24">
          <!-- 第一行 -->
          <a-col :xl="6" :lg="8" :md="12" :sm="24">
            <a-form-item label="客户编号" class="compact-form-item">
              <a-input
                  v-decorator="['customerNo']"
                  placeholder="请输入客户编号"
                  allow-clear
                  class="compact-input"
              />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="8" :md="12" :sm="24">
            <a-form-item label="记录状态" class="compact-form-item">
              <a-select
                  v-decorator="['status']"
                  placeholder="请选择状态"
                  allow-clear
                  class="compact-select"
              >
                <a-select-option :value="0">已撤销</a-select-option>
                <a-select-option :value="1">已发放</a-select-option>
                <a-select-option :value="2">已使用</a-select-option>
                <a-select-option :value="3">已过期</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="8" :md="12" :sm="24">
            <a-form-item label="关联订单" class="compact-form-item">
              <a-input
                  v-decorator="['relatedId']"
                  placeholder="请输入关联订单号"
                  allow-clear
                  class="compact-input"
              />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="8" :md="12" :sm="24" class="search-actions">
            <a-form-item class="compact-form-item">
              <a-space :size="16">
                <a-button type="primary" icon="download" @click="handleAsyncExportXls()" :loading="exportLoading"
                          class="export-btn">导出
                </a-button>
                <a-button type="primary" @click="handleSearch" class="search-btn">查询</a-button>
                <a-button @click="handleReset" class="reset-btn">重置</a-button>
              </a-space>
            </a-form-item>
          </a-col>
        </a-row>

        <!-- 第二行 -->
        <!--        <a-row :gutter="24">-->
        <!--          <a-col :xl="8" :lg="12" :md="12" :sm="24">-->
        <!--            <a-form-item label="时间范围" class="compact-form-item">-->
        <!--              <a-range-picker-->
        <!--                  v-decorator="['dateRange']"-->
        <!--                  show-time-->
        <!--                  format="YYYY-MM-DD HH:mm:ss"-->
        <!--                  class="compact-range-picker"-->
        <!--              />-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--        </a-row>-->
      </a-form>
      <!-- 表格区域 -->
      <a-table
          :columns="columns"
          :dataSource="tableData"
          :pagination="pagination"
          :loading="loading"
          rowKey="id"
          bordered
          @change="handleTableChange"
      >
        <template slot="recordType" slot-scope="text">
          <a-tag :color="getRecordTypeColor(text)">
            {{ getRecordTypeText(text) }}
          </a-tag>
        </template>

        <template slot="status" slot-scope="text">
          <a-tag :color="getStatusColor(text)">
            {{ getStatusText(text) }}
          </a-tag>
        </template>

        <template slot="rebatePoints" slot-scope="text">
            <span :class="{ 'positive': text > 0, 'negative': text < 0 }">
              {{ text > 0 ? `+${text}` : text }}
            </span>
        </template>

        <template slot="createTime" slot-scope="text">
          {{ formatDateTime(text) }}
        </template>

        <template slot="expiryDate" slot-scope="text">
          {{ text ? formatDate(text) : '永久有效' }}
        </template>
        <template slot="relatedId" slot-scope="text">
          <div class="break-lines">{{ text || '-' }}</div>
        </template>
      </a-table>
    </div>
  </a-modal>
</template>

<script>
import {message} from 'ant-design-vue';
import dayjs from 'dayjs';
import {getPointsRecords} from 'api/points';
import {AsyncExportMixin} from '@/mixins/asyncExportMixin'

export default {
  mixins: [AsyncExportMixin],
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ruleId: null,
      searchForm: this.$form.createForm(this),
      tableData: [],
      loading: false,
      url: {
        exportTaskUrl: 'ndt/export/task/point/record/async',
        exportStatusUrl: '/ndt/export/task/status'
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50']
      },
      // 表格列配置
      columns: [
        {
          title: '客户编号',
          dataIndex: 'customerNo',
          key: 'customerNo',
          width: 120,
          align: 'center'
        },
        {
          title: '记录类型',
          dataIndex: 'recordType',
          key: 'recordType',
          width: 100,
          align: 'center',
          scopedSlots: {customRender: 'recordType'}
        },
        {
          title: '积分变动',
          dataIndex: 'rebatePoints',
          key: 'rebatePoints',
          width: 100,
          align: 'center',
          scopedSlots: {customRender: 'rebatePoints'}
        },
        // {
        //   title: '剩余积分',
        //   dataIndex: 'remainingPoints',
        //   key: 'remainingPoints',
        //   width: 100,
        //   align: 'center'
        // },
        {
          title: '关联金额(USD)',
          dataIndex: 'relatedAmount',
          key: 'relatedAmount',
          width: 120,
          align: 'center',
          customRender: text => text ? `${text}` : '-'
        },
        {
          title: '关联订单',
          dataIndex: 'relatedId',
          key: 'relatedId',
          width: 150,
          align: 'center',
          scopedSlots: { customRender: 'relatedId' }
        },
        {
          title: '来源',
          dataIndex: 'consumerSource',
          key: 'consumerSource',
          width: 150,
          align: 'center',
          ellipsis: true
        },
        {
          title: '记录状态',
          dataIndex: 'status',
          key: 'status',
          width: 100,
          align: 'center',
          scopedSlots: {customRender: 'status'}
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          key: 'createTime',
          width: 180,
          align: 'center',
          scopedSlots: {customRender: 'createTime'}
        },
        {
          title: '过期时间',
          dataIndex: 'expiryDate',
          key: 'expiryDate',
          width: 120,
          align: 'center',
          scopedSlots: {customRender: 'expiryDate'}
        }
      ]
    };
  },

  methods: {
    // 设置规则ID并加载数据
    setRuleId(ruleId) {
      this.ruleId = ruleId;
      this.loadData();
    },

    // 加载数据
    async loadData() {
      if (!this.ruleId) return;

      try {
        this.loading = true;
        const values = this.searchForm.getFieldsValue();
        const params = {
          ruleId: this.ruleId,
          ...values,
          current: this.pagination.current,
          size: this.pagination.pageSize
        };

        // 处理日期范围
        if (values.dateRange && values.dateRange.length === 2) {
          params.startTime = values.dateRange[0].format('YYYY-MM-DD HH:mm:ss');
          params.endTime = values.dateRange[1].format('YYYY-MM-DD HH:mm:ss');
        }

        const res = await getPointsRecords(params);
        if (res && res.data) {
          this.tableData = res.data.records || [];
          this.pagination.total = res.data.total || 0;
        } else {
          message.error('获取数据失败');
        }
      } catch (error) {
        console.error('加载数据失败:', error);
        message.error('加载数据失败');
      } finally {
        this.loading = false;
      }
    },

    // 查询
    handleSearch() {
      this.pagination.current = 1;
      this.loadData();
    },

    // 重置
    handleReset() {
      this.searchForm.resetFields();
      this.handleSearch();
    },

    // 分页变化
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.loadData();
    },

    // 关闭弹窗
    handleCancel() {
      this.$emit('cancel');
    },

    // 辅助方法保持不变
    getRecordTypeText(type) {
      const map = {
        1: '充值',
        2: '消费',
        3: '充值赠送',
        4: '手动发放'
      };
      return map[type] || '未知类型';
    },

    getRecordTypeColor(type) {
      const map = {
        1: 'blue',
        2: 'green',
        3: 'orange',
        4: 'red'
      };
      return map[type] || 'default';
    },

    getStatusText(status) {
      const map = {
        0: '已撤销',
        1: '已发放',
        2: '已使用',
        3: '已过期'
      };
      return map[status] || '未知状态';
    },

    getStatusColor(status) {
      const map = {
        0: 'red',
        1: 'green',
        2: 'blue',
        3: 'gray'
      };
      return map[status] || 'default';
    },

    formatDateTime(time) {
      return dayjs(time).format('YYYY-MM-DD HH:mm:ss');
    },

    formatDate(date) {
      return dayjs(date).format('YYYY-MM-DD');
    },
    getQueryParams() {
      const values = this.searchForm.getFieldsValue();
      const params = {
        ruleId: this.ruleId,
        ...values
      };
      if (values && values.dateRange && values.dateRange.length === 2) {
        params.startTime = values.dateRange[0].format('YYYY-MM-DD HH:mm:ss');
        params.endTime = values.dateRange[1].format('YYYY-MM-DD HH:mm:ss');
        delete params.dateRange;
      }
      return params;
    }
  }
}
</script>

<style lang="less" scoped>
.points-detail {
  padding: 0;
}

.custom-search-form {
  .compact-form-item {
    margin-bottom: 16px;

    /deep/ .ant-form-item-label {
      line-height: 32px;
      padding-right: 8px;
    }

    /deep/ .ant-form-item-control {
      line-height: 32px;
    }
  }

  .compact-input, .compact-select {
    width: 100%;
    min-width: 180px;
  }

  .compact-range-picker {
    width: 100%;
    min-width: 280px;
  }

  .search-actions {
    display: flex;
    justify-content: flex-end;

    .search-btn, .reset-btn {
      min-width: 80px;
    }
  }

  @media (max-width: 768px) {
    .compact-form-item {
      margin-bottom: 12px;
    }

    .search-actions {
      justify-content: flex-start;
    }
  }
}
.break-lines {
  white-space: pre-line;
  word-break: break-word;
}
</style>
